module.exports = __webpack_public_path__ + "img/kitchen-faucet.624e785f.svg";